import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch from "../../../utils/hooks/useFetch.ts";
import { queryClient } from "../../queryClient.ts";
import { Urls } from "../../urls.ts";

export const useCheckIn = () => {
  const { token } = useAuth();
  const fetch = useFetch();

  return useMutation({
    mutationFn: (data: string[]) => {
      const response = fetch(`${Urls.CheckIn}?${data.map(id => `adminIds=${encodeURIComponent(id)}`).join('&')}`, {
        method: "POST"
      }, true, token);

      return response;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ["checkInStatus"]})
    },
    onError: (error) => {
      toast.error(error?.message || "Error checking in");
    },
  });
};
